const typeText = {
  warning: '警告消息',
  error: '错误信息',
  default: '打印信息'
}

const typeColor = {
  warning: '#ff9900',
  error: '#f03f14',
  default: '#2d8cf0'
}

/**
 * 组件选项打印
 * @param cname 组件名称
 * @param content 打印内容
 * @param type 类型
 */
export function log(cname: string, content: string, type: 'warning' | 'error' | 'default' = 'default') {
  const text = typeText[type]
  const color = typeColor[type]
  console.log(
    `%c ${cname} %c ${text} %c ${content}`,
    'background:#35495e ; padding: 1px; border-radius: 3px 0 0 3px;  color: #fff;',
    `background:${color} ; padding: 1px; border-radius: 0 3px 3px 0;  color: #fff`,
    `background:transparent; color: ${ type === 'error' ? '#f03f14' : '#000' }`
  )
}

